<template xmlns:v-tooltip="http://www.w3.org/1999/xhtml">
  <span>
    <span v-if="isMe && $store.state.edit.on">
      <span v-if="!editing" class="block">
        <div class="row">
          <div class="col-sm-11">
            <span class="iblock" @click="edit" @mouseover="hover = true" @mouseout="hover = false">
              <span v-if="skills.length > 0">{{ skills.join(', ') }}</span>
              <span v-else v-tooltip:top="$t(placeholder)" class="btn btn-default btn-sm">
                {{ $t('add :nameOfItemsToAdd', { nameOfItemsToAdd: fieldName }) }}
              </span>
            </span>
          </div>
          <div class="col-sm-1 text-left">
            <i v-show="hover && !loader" class="zmdi zmdi-edit c-gray" />
            <div class="m-h-20" style="margin-top: -15px; margin-left: -15px">
              <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
              <NetworkLoader :loader="loader" :failed="failed" />
            </div>
          </div>
        </div>
      </span>
      <span v-else style="position: relative; z-index: 4; display: block">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <type-select
          :name="fieldName"
          :locale-in="language"
          :selected-in="[...skills]"
          :placeholder="$t(placeholder)"
          :tag-type="tagType"
          :show-typesuggestions="false"
          :can-add-unsupported-types="canAddUnsupportedTypes"
          @selection-changed="skillsChanged"
        />
        <a href="#" class="btn btn-success waves-effect" @click="saveChanges">
          {{ $t('Done') }}
        </a>
      </span>
    </span>
    <span v-else class="skills">
      <span
        v-for="skill in skills
          .slice(0, limiter)
          .map((tag) => tag.charAt(0).toUpperCase() + tag.slice(1))"
        :key="skill"
        :class="skillClasses"
        class="label"
      >
        {{ skill }}
      </span>
      <a v-if="skills.length - limiter > 0" href="#" class="label label-basic" @click="showAll">
        + {{ $t(':count more', { count: skills.length - limiter }) }}
      </a>
    </span>
  </span>
</template>

<script>
import enums from '@/utils/enum'
import {
  SET_EDIT_UNSAVED,
  SET_EDITABLE_ACTIVE_STATE,
  UPDATE_USER_STATE,
} from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'
import { UPDATE_FREELANCER } from '@/state/apollo/accounts'
import { NetworkError } from '@/utils/notification'

export default {
  name: 'ComponentEditTags',
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    fieldName: {
      required: true,
      type: String,
    },
    canAddUnsupportedTypes: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    selectedIn: {
      type: Array,
      required: true,
    },
    tagType: {
      required: true,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
      default: 'Enter other job titles you match (separate by comma)',
    },
    skillClasses: {
      required: false,
      type: Object,
      default: () => ({
        'c-purple': true,
        'bgm-lightgray': true,
      }),
    },
  },
  data() {
    return {
      loader: false,
      failed: false,
      hover: false,
      editing: false,
      limiter: 5,
      skills: [],
    }
  },
  watch: {
    loader(saving) {
      this.$store.dispatch(SET_EDIT_SAVING_STATE, saving)
    },
    '$store.state.edit.on': function (setting) {
      if (!setting && this.editing) {
        // We just turned off edit on the global button, and we are still in editing mode
        this.saveChanges()
      }
    },
    editing(val) {
      this.$store.commit(SET_EDIT_UNSAVED, val)
    },
  },
  created() {
    this.skills = [...this.selectedIn]
    this.$store.commit(UPDATE_USER_STATE, {
      fieldName: this.fieldName,
      fieldValue: this.selectedIn,
    })
  },
  methods: {
    edit() {
      this.editing = true
      this.$store.commit(SET_EDITABLE_ACTIVE_STATE, true)
    },
    skillsChanged(skills) {
      this.skills = skills
    },
    async saveChanges() {
      const app = this
      app.failed = false
      app.editing = false
      app.loader = true
      app.hover = false
      this.$store.commit(SET_EDITABLE_ACTIVE_STATE, false)
      this.$store.commit(UPDATE_USER_STATE, {
        fieldName: this.fieldName,
        fieldValue: this.skills,
      })
      this.$store.commit(SET_EDIT_UNSAVED, true)
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_FREELANCER,
          variables: {
            input: {
              globalId: this.account.globalId,
              [this.fieldName]: this.skills,
            },
          },
        })
        this.$store.commit(SET_EDIT_UNSAVED, false)
      } catch (e) {
        this.$store.commit(SET_EDIT_UNSAVED, true)
        new NetworkError({
          severity: enums.notification.severity.CRITICAL,
          ex: e,
        }).dispatch(this)
        this.$store.commit('sendNotification')
        app.failed = true
      }
      app.loader = false
    },
    showAll() {
      this.limiter = 10000
    },
  },
}
</script>

<style scoped lang="scss">
.dropdown-toggle {
  border: none;
}
i {
  position: absolute;
  margin-left: 5px;
}
.pullup {
  margin-top: -7px;
  top: 0;
}
.right-text {
  top: 5px;
  right: 0;
}
</style>
